
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/scta-notation",
      function () {
        return require("private-next-pages/next/scta-notation.tsx");
      }
    ]);
  